import api from '../../config/axios.js';

const state = {
    prices: {},
    loadingPrices: false,
    errorPrices: ""
}

const getters = {
    getPrices: state => state.prices,
    getLoadingPrices: state => state.loadingPrices,
    getErrorPrices: state => state.errorPrices
}

const actions = {
    async setPrices({ commit }) {
        commit("setLoadingPrices", true);
        commit("setErrorPrices", "");

        await api.axios.get('/api/prices').catch(error => {
            if(error && error.response && error.response.data && error.response.data){
                commit("setErrorPrices", error.response.data);
            }
        }).then(function(response){
            if(response && response.status == 200){
                commit('setPrices', response.data);
            }
        }).finally(function(){
            commit("setLoadingPrices", false);
        });
    }
}

const mutations = {
    setPrices: function(state, data){
        state.prices = data || {};
    },
    setLoadingPrices: function(state, data){
        state.loadingPrices = data;
    },
    setErrorPrices: function(state, data){
        state.errorPrices = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
